export const CilindroTipo = {
  Codigo: null,
  Descripcion: null,
};

export const initialCylinderAdapter = {
  Codigo: null,
  CodigoCilindroTipo: null,
  Dientes: null,
  Paso: null,
  CilindroTipo,
};

export const initial_filters = {
  CodigoCilindroTipo: null,
};
